/**
 * LayoutToggle — grid/spotlight mode toggle button (T006 / US1).
 *
 * Rendered inside the Controls toolbar when remotePeerCount >= 1 (FR-002).
 * Reads layoutMode from the store and calls setLayoutMode to flip it.
 * Exposes aria-pressed = true when spotlight is active (FR-011 / C1).
 */
import { useTranslation } from 'react-i18next'
import { useRoomStore } from '../room/store.js'
import styles from './Controls.module.css'

export function LayoutToggle() {
  const { t } = useTranslation()
  const layoutMode = useRoomStore((s) => s.layoutMode)
  const setLayoutMode = useRoomStore((s) => s.setLayoutMode)

  const isSpotlight = layoutMode === 'spotlight'

  function handleClick() {
    setLayoutMode(isSpotlight ? 'grid' : 'spotlight')
  }

  return (
    <button
      data-testid="control-layout-toggle"
      type="button"
      className={`${styles.btn} ${isSpotlight ? styles.btnOn : ''}`}
      aria-label={isSpotlight ? t('layout.toGrid') : t('layout.toSpotlight')}
      aria-pressed={isSpotlight}
      onClick={handleClick}
    >
      {isSpotlight ? <GridIcon /> : <SpotlightIcon />}
      <span className={styles.btnLabel}>
        {isSpotlight ? t('layout.toGrid') : t('layout.toSpotlight')}
      </span>
    </button>
  )
}

// ---------------------------------------------------------------------------
// Inline SVG icons
// ---------------------------------------------------------------------------

function GridIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="3" y="3" width="7" height="7" />
      <rect x="14" y="3" width="7" height="7" />
      <rect x="3" y="14" width="7" height="7" />
      <rect x="14" y="14" width="7" height="7" />
    </svg>
  )
}

function SpotlightIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {/* Large left panel */}
      <rect x="2" y="3" width="13" height="18" rx="1" />
      {/* Small right tiles */}
      <rect x="17" y="3" width="5" height="8" rx="1" />
      <rect x="17" y="13" width="5" height="8" rx="1" />
    </svg>
  )
}
